
export const ServicePlaceHolder = ({ width, height }) => {
    return (
        <div className="ui placeholder fluid" style={{width: width, height: height}}>
            <div className="image"></div>
        </div>
    )
}

export const SliderImagePlaceHolder = ({ height }) => {
    return(
        <div className="ui card" style={{width:'100%', margin: "0px"}}>
          <div className="content" style={{padding:"6px"}}>
            <div className="ui placeholder fluid">
              <div className="rectangular image" style={{paddingTop: height}}></div>
            </div>
          </div>
        </div>
    )
}

